<template>
  <div class="tableWrapper">
    <div class="tableHeader textStyle">
      <div class="projectName">{{$t('foldersTable.projectName')}}</div>
      <div class="totalTime">{{$t('foldersTable.totalTime')}}</div>
      <div class="lastEdited">{{$t('foldersTable.lastEdited')}}</div>
      <div class="audiosCount">{{$t('foldersTable.audiosCount')}}</div>
    </div>
    <template v-for="item in folders">
      <FolderInfo
        :folderInfo="{
          name: item.name,
          time: item.id,
          created_date: item.created_date,
          audiosCount: item.total,
          id: item.id,
          total_synthesized: item.total_synthesized,
        }"
        :whereToOpen="whereToOpen"
        :updateList="updateList"
        :key="item.id"
        ><slot
      /></FolderInfo>
    </template>
  </div>
</template>
<script>
import FolderInfo from "../components/FolderInfo";
export default {
  name: "FoldersTable",
  components: { FolderInfo },
  props: {
    folders: Array,
    whereToOpen: String,
    updateList: { type: Function },
  },
};
</script>

<style scoped>
.tableWrapper {
  width: 100%;
  height: 541px;
  margin-bottom: 20px;
}

.tableHeader {
  display: flex;
  max-width: 100%;
}

.textStyle {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
}

.projectName {
  width: 25%;
  min-width: 200px;
  margin-right: 30px;
}

.totalTime {
  min-width: 88px;
  margin-right: 30px;
}

.lastEdited {
  min-width: 140px;
  margin-right: 30px;
}

.audiosCount {
  min-width: 89px;
  margin-right: 30px;
}

.otherThings {
  width: 20%;
}

@media screen and (max-width: 900px) {
  .projectName {
    width: 70%;
  }

  .otherThings {
    width: 30%;
  }
  .audiosCount,
  .lastEdited,
  .totalTime {
    display: none;
  }
}
</style>
